module.exports = __webpack_public_path__ + "img/XT-Soldadoras.ab9abdfb.png";